import { render, staticRenderFns } from "./MyParagraph.vue?vue&type=template&id=31cf58e4&scoped=true&"
import script from "./MyParagraph.vue?vue&type=script&lang=js&"
export * from "./MyParagraph.vue?vue&type=script&lang=js&"
import style0 from "./MyParagraph.vue?vue&type=style&index=0&id=31cf58e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cf58e4",
  null
  
)

export default component.exports